module.exports = __webpack_public_path__ + "static/LauraBagk-7ea859c7f8842e0e8cb444560f2f4a37.jpg";